import { useTranslations } from '../../../hooks';
import { INITIAL_INFO_TRANSALTIONS } from './const';
import { InfoTranslateions } from './types';

export const useInfoTranslations = (translations: Partial<InfoTranslateions>) => useTranslations(translations, INITIAL_INFO_TRANSALTIONS);
